var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultipleNeutral2StreamlineUltimate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.375 7.875a4.125 4.125 0 1 0 8.25 0 4.125 4.125 0 0 0-8.25 0ZM.75 20.25a6.75 6.75 0 0 1 13.5 0m.102-10.125a3.375 3.375 0 1 0 6.75 0 3.375 3.375 0 0 0-6.75 0Zm1.461 4.943a5.525 5.525 0 0 1 7.437 5.182"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleNeutral2StreamlineUltimate);
export default __webpack_public_path__ + "static/media/Multiple-Neutral-2--Streamline-Ultimate.8309a69ade07df4b9ea5cc0e8b99e6c2.svg";
export { ForwardRef as ReactComponent };